import { render } from "./MinistryUpdate.vue?vue&type=template&id=6456c69d&scoped=true"
import script from "./MinistryUpdate.vue?vue&type=script&lang=js"
export * from "./MinistryUpdate.vue?vue&type=script&lang=js"

import "./MinistryUpdate.vue?vue&type=style&index=0&id=6456c69d&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6456c69d"]])

export default __exports__